import type { ReactNode } from "react";

export interface FormSectionProps {
  readonly title: string;
  readonly description?: string;
  readonly children: ReactNode;
}

/** One titled group of a KPI form as the Direction B canvas draws it (PB-5134,
 * d37): a soft card, a 14px semibold title, an optional muted line, then the
 * fields with the canvas' 18px rhythm. */
export function FormSection({
  title,
  description,
  children,
}: FormSectionProps): JSX.Element {
  return (
    // Kept hand-built (not Card+CardHeader/CardBody): Card's fixed fill
    // opacities (bg-pb-card, or bg-pb-card-elevated/60 on `inset`) don't
    // reproduce this translucent bg-pb-card/40, and CardHeader's divider
    // has no "off" match for this section's undivided title-then-fields
    // layout without a colour/fill change no T01 row approves.
    <section className="rounded-xl border border-pb-border/70 bg-pb-card/40 px-5 py-4.25">
      <div className="mb-3.75">
        <h2 className="text-body font-semibold tracking-tight text-pb-text">
          {title}
        </h2>
        {description ? (
          <p className="mt-0.5 text-caption text-pb-text-muted">
            {description}
          </p>
        ) : null}
      </div>
      <div className="space-y-4.5">{children}</div>
    </section>
  );
}
